import { render, staticRenderFns } from "./CostCard.vue?vue&type=template&id=3258bab3&scoped=true"
import script from "./CostCard.vue?vue&type=script&lang=js"
export * from "./CostCard.vue?vue&type=script&lang=js"
import style0 from "./CostCard.vue?vue&type=style&index=0&id=3258bab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258bab3",
  null
  
)

export default component.exports